import * as moment from 'moment';

import {
  Component,
  Input,
  forwardRef,
  ElementRef,
  NgZone,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  SimpleChanges,
} from '@angular/core'

import { DropdownComponent } from '@burt-ui'
import { BenchmarkService } from '../../services/benchmark/benchmark.service'
import { DynamicDateRange } from '../../modules/date-range-picker/types';

import {
  NG_VALUE_ACCESSOR
} from '@angular/forms'

export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BenchmarksComponent),
  multi: true,
}

@Component({
  selector: 'benchmarks',
  host: {
    class: 'ui selection dropdown'
  },
  styleUrls: ['benchmarks.component.less'],
  templateUrl: 'benchmarks.component.html',
  providers: [
    VALUE_ACCESSOR
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BenchmarksComponent extends DropdownComponent {
  @Input() dates: DynamicDateRange
  @Input() format = 'MMM D, YYYY'
  @Input() queryFirstDayOfWeek: string = undefined
  @Input() set triggerChange(value: number | boolean) {
    if (value !== false) {
      this.onDropdownChange(value);
    }
  }

  range: string
  currentValue: any
  defaultValue: any = {name: 'None', value: 'none'}

  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    changeDetectorRef: ChangeDetectorRef,
    private benchmarkService: BenchmarkService
  ) {
    super(elementRef, ngZone, changeDetectorRef)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.settings || !this.dropdownSettings) {
      this.dropdownSettings = Object.mergeAll({}, [this.DEFAULT_SETTINGS, (this.settings || {})], { deep: true })
    }

    if (this.options) {
      if (this.options.length > 0) {
        this.ensureNames()
      }
      this.createItems()
      this.trySetDefaultSelected()
    }

    if (this.dates) {
      this.setRange()
    }
  }

  setSelected(modelValue) {
    this.currentValue = modelValue
    if (this.items) {
      setTimeout(() => {
        const itemValue = this.getItemValue(modelValue)
        this.setRange()
        if (itemValue == null) {
          this.$element.dropdown('clear')
        } else {
          this.$element.dropdown('set selected', itemValue)
        }
        this.defaultSelected = null
      })
    }
    this.settingValue = true
  }

  setRange() {
    if (this.currentValue
      && this.currentValue.value !== 'none'
      && this.dates
    ) {
      const benchmarks = this.benchmarkService.calculateBenchmark(this.dates, this.currentValue.value, this.queryFirstDayOfWeek ? Number(this.queryFirstDayOfWeek) : undefined)
      this.range = `${moment(benchmarks['startDate']).format(this.format)} - ${moment(benchmarks['endDate']).format(this.format)}`

    } else {
      this.range = ''
    }
    this.changeDetectorRef.markForCheck()
  }

  onDropdownChange(value) {
    const index = parseInt(value, 10)
    this.currentValue = this.options?.[index] ?? this.defaultValue
    this.setRange()
    this.ngZone.run(() => {
      this.fireOnChange(value)
    })
  }
}
